import type { ReactElement } from 'react'
import React from 'react'
import { twMerge } from 'tailwind-merge'

import { getFontColor } from '@ui-kit/components/Bars/TopBar/utils'
import ButtonIcon from '@ui-kit/components/ButtonIcon/index.web'
import { body2 } from '@ui-kit/core/typography'
import { bgColor } from '@ui-kit/styles/colors'

import { topBar } from './styles'
import type { WebProps } from './types'

const TopBar = (props: WebProps): ReactElement => (
  <div
    className={twMerge(
      'flex flex-row items-center justify-center gap-x-2.5 bg-playground4-light p-2.5',
      props.bgColor && bgColor({ color: props.bgColor }),
      props.onClick && 'cursor-pointer',
      props.className
    )}
    style={props.style}
    onClick={props.onClick}
  >
    {typeof props.iconLeft === 'string' ? (
      <img className={topBar().image()} src={props.iconLeft} alt="" />
    ) : (
      props.iconLeft && <ButtonIcon icon={props.iconLeft} onClick={props.onIconClick} />
    )}
    {props.text ? (
      <p className={body2({ bold: props.isBold, color: getFontColor(props.bgColor) })}>
        {props.text}
      </p>
    ) : (
      props.content
    )}
    {props.iconRight && <ButtonIcon icon={props.iconRight} onClick={props.onIconClick} />}
  </div>
)

export default TopBar
